(function () {
    'use strict';

    angular.module('directives.govClosedTag', [])
        .directive('govClosedTag', directive);

    directive.$inject = [];

    function directive() {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: require('./govClosedTag.tpl.html')
        };
    }
})();